import Model from 'src/storage/base';

class PatientTreatmentDetailModel extends Model {
  id = 'PatientTreatmentDetailModel';
  defaultState = () => ({
    treatment: null,
    isImproved: true,
    status: 'in_process',
    improvedComment: '',
    isEffect: true,
    effectComment: '',
    files: [],
    media: [],
  });

  apiConfig = {
    treatment_detail: {
      url: 'treatment/detail',
      validation: {
        messageId: 'string'
      },
      cancellable: true
    },
    addFeedBack: {
      url: '/treatment/update/feedback',
      validation: {
        id: 'baseId',
        status: 'string',
        isImproved: 'isImproved',
        improvedComment: 'improvedComment',
        isEffect: 'isEffect',
        effectComment: 'effectComment',
      },
      cancellable: true
    },
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        id: 'number'
      },
      cancellable: true
    },
  };
  _events = {
    'foxsocket:message:treatment': 'onUpdate',
    profile: 'handleProfile',
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  onUpdate = ({ data }) => {
    if (this.state.treatment?.id === data.id) {
      const {treatment, doctor} = this.state;
      this.setState({treatment: {...treatment, ...data, doctor}});
    }
  }

  loadDetail = (messageId, cb) => {
    this.api('treatment_detail', { messageId }, (error, treatment, success) => {
      if (success) {
        this.setState({treatment});
      }
      cb && cb(error, treatment, success);
    });
  };

  loadDoctorDetail = (id) => {
    this.api('doctor_detail', { id }, (error, doctor, success) => {
      if (success) {
        this.setState({treatment: {...this.state.treatment, doctor}, doctor});
      }
    });
  };

  addFeedback = (cb) => {
    let req = {
      id: this.state.treatment.id,
      files: this.state.files,
      status: this.state.status,
      isImproved: this.state.isImproved,
      improvedComment: this.state.improvedComment,
      isEffect: this.state.isEffect,
      effectComment: this.state.effectComment,
      media: this.state.media
    };
    const fn = (err, data, success) => {
      cb(err, data, success);
      this.resetAddFeedback();
    }
    this.api('addFeedBack', req, fn);
  };

  resetAddFeedback = (feedback = {}) => {
    this.setState({
      isImproved: !!feedback.isImproved,
      status: feedback.status || 'in_process',
      improvedComment: feedback.improvedComment || '',
      isEffect: !!feedback.isEffect,
      effectComment: feedback.effectComment || '',
      files: [],
      media: feedback?.media || [],
    });
  };
}

const model = new PatientTreatmentDetailModel();
export default model;
